/*
 * File: Login.styles.js
 * Project: lets-talk-web
 *
 * Created by Brendan Michaelsen on January 30, 2022 at 12:11 AM
 * Copyright © 2022 Let's Talk. All rights reserved.
 *
 * Last Modified: March 9, 2026 at 11:59 PM
 * Modified By: Anisha Verma
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Components
import { Button, Padding, Typography } from '../../../components';

// Constants
import { mobileBreakpoint } from '../../../styles/constants';


/**
 * Styles
 */

export const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	display: block;
	position: relative;
	text-align: center;

	.uiModeWidget {
		position: absolute;
		z-index: 2;
		top: 10px;
		right: 10px;
	}
`;

export const Logo = styled.img`
	width: 80px;
	margin: 40px auto;
	text-align: center;

	@media only screen and (min-width: ${mobileBreakpoint}em) {
		width: 100px;
		margin: 60px auto;
	}
`;

export const Form = styled.form`
	width: 100%;
	max-width: 650px;
	margin: 0px auto;

	@media only screen {
		padding-top: 20px;
		padding-bottom: 30px;
	}
	@media only screen and (min-width: ${mobileBreakpoint}em) {
		padding-top: 20px;
		padding-bottom: 30px;
	}
	.cardPadding {
		padding: 50px;
	}
	h2 {
		text-align: center;
		margin: 10px 0px 10px;
	}
	p {
		text-align: center;
   		margin-bottom: 40px;
		color: ${({ theme }) => theme.secondaryText};
	}
	& > p {
		margin-bottom: 40px;
	}
	button {
		width: 100%;

		* {
			margin: 0px;
		}
	}
`;

export const ForgotPasswordContainer = styled.div`
	margin: 7px 0px 2px;
    text-align: right;
    width: 100%;
`;

export const ForgotPasswordButton = styled(Button)`
	width: auto !important;
	display: inline-block;
	padding: 0px;
`;

export const BottomActionContainer = styled.div`
	margin: 14px 0px 2px;
    text-align: center;
    width: 100%;

	button {
		padding: 0px;
		display: inline-block;
		width: auto;
	}
	p {
		margin: 0px;
		display: inline-block;

		span {
			font-size: inherit !important;
			color: ${({ theme }) => theme.brandPrimaryBase};
		}
	}
`;

export const Decoration = styled.div`
	position: fixed;
	z-index: 1;
	width: 100%;
	height: 100%;
	left: 0px;
	bottom: 0px;
	background-image: url('${process.env.CDN_URL}/public/assets/decorations/green-wave-decoration.png');
	background-size: cover;
	background-position: 50% 40vh;
	background-repeat: no-repeat;
`;

export const FormContainer = styled(Padding)`
	z-index: 2;
	position: relative;
`;

export const CheckboxRow = styled.div`
	display: flex;
	margin: 20px 0 0 0;
	align-items: center;

	span {
		flex-grow: 1;
		text-align: left;
		margin: 0 0 0 12px;
		position: relative;
		top: -1px;
		color: ${({ theme }) => theme.secondaryText};

		a,
		a:link,
		a:visited {
			color: inherit;
		}
	}
`;

export const SSOSectionTitle = styled(Typography)`
	margin: 8px 0 18px !important;
	text-align: center;
	color: #6f6f6f !important;
`;

export const SSOContainer = styled.div`
	width: 100%;
	margin: 10px 0px 20px;
	display: flex;
	flex-direction: column;
	gap: 12px;
`;


export const SSOButton = styled(Button)`
	width: 100%;
	height: 44px; 
	background: #ffffff !important;
	border: 1.5px solid #849cd0ff !important; 
	border-radius: 999px !important;
	box-shadow: none !important;
	padding: 0 16px !important;

	display: flex;
	align-items: center;
	justify-content: center;

	span,
	p,
	div {
		color: #1e2f5c !important;
	}

	&:hover {
		background: #f3efefff !important;
		border-color: #849cd0ff !important;
	}
`;


export const SSOButtonContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0px; 
`;

export const SSOIcon = styled.img`
	width: 50px;
	height: 18px;
	object-fit: contain;
	flex-shrink: 0;
`;

export const SSOButtonText = styled.span`
	font-size: 15px;
	font-weight: 600;
`;


export const CheckboxContainer = styled.div`
	margin: 20px 0px 35px;
`;
